export const gameData = {
  frameRate: 16,
  isShooting: false,
};
